import React from 'react';
import Alert from './Alert.js';

const NotFound = () => {
  return <Alert isHtml message="page.not.found"
          linkText="tästä"
          linkHref="#"/>;
};

export default NotFound;
